"use client";

import React from "react";
import { Badge } from "@/components/ui/badge";
import { Card, CardContent } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
import { PostsProvider, usePosts } from "@/integrations/wordpress/WordPressPostsProvider";
import { WP_Query } from "@/integrations/wordpress/wp_query";
function RelatedArticlesConsumer() {
  const {
    posts,
    loading,
    error
  } = usePosts();
  if (loading) {
    return <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6 lg:gap-8">
                {[...Array(3)].map((_, i) => <div key={i} data-index={i} className="animate-pulse flex flex-col gap-4 sm:gap-5 p-4 sm:p-5 lg:p-6 bg-white rounded-xl">
                        <div className="bg-muted rounded-[6px] aspect-[4/3] w-full" />
                        <div className="h-6 bg-muted rounded w-full mt-2" />
                        <div className="h-6 bg-muted rounded w-2/3" />
                    </div>)}
            </div>;
  }
  if (error) {
    return <div className="text-destructive text-center py-8">
                Gagal memuat artikel terkait.
            </div>;
  }
  if (!posts || posts.length === 0) {
    return <div className="text-muted-foreground text-center py-8">
                Tidak ada artikel terkait saat ini.
            </div>;
  }
  return <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6 lg:gap-8">
            {posts.map((post, i) => <Link key={post.id} to={post.link || "#"} data-index={i} className="group block h-full">
                    <Card className="h-full border-none shadow-none bg-white hover:shadow-md transition-shadow duration-300 p-4 sm:p-5 lg:p-6 gap-4 sm:gap-5 rounded-xl flex flex-col">
                        <div className="relative overflow-hidden rounded-[6px] aspect-[4/3] shrink-0">
                            {post.categories && post.categories.length > 0 && <Badge className="absolute top-3 left-3 z-10 shadow-sm font-medium">
                                    {post.categories[0].name}
                                </Badge>}
                            <img src={post.featuredImage || "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/generic_article_thumb.png"} alt={post.title} className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105" />
                        </div>
                        <CardContent className="p-0 flex-grow">
                            <h3 className="text-base sm:text-lg lg:text-[20px] font-sans font-semibold leading-snug text-foreground line-clamp-3">
                                {post.title}
                            </h3>
                        </CardContent>
                    </Card>
                </Link>)}
        </div>;
}
export default function RelatedArticles() {
  const wp_query_params = {
    per_page: 3
  };
  const wp_query = new WP_Query(wp_query_params);
  return <section id="artikel-terkait" className="py-16 bg-background">
            <div className="container mx-auto px-4 md:px-6">
                <div className="mb-8">
                    <h2 className="text-2xl md:text-3xl font-bold text-foreground">
                        Artikel Terkait
                    </h2>
                </div>
                <PostsProvider wp_query={{
        per_page: 3
      }}>
                    <RelatedArticlesConsumer />
                </PostsProvider>
            </div>
        </section>;
}